
import React, { useState, useContext, useEffect } from 'react';
import {IProps} from './types';
import C from '@assets/themes/colors';
import { Layer, Rect, Text, Group, Transformer, Label, Tag } from 'react-konva';
import Konva from 'konva';
import { IArtboardAttributes } from '@routes/private/Editor/types';
import { reverseScale } from '@utils/editor';
import { useSelector } from 'react-redux';
import selectors from '@state/selectors';
import { KonvaEventObject } from 'konva/lib/Node';
import {getArtboardPreview} from '@utils/artboard'
import { IResizeValues } from '@routes/private/Editor/Editor/CommandsBars/MainCommandBar/CommandsOptions/ResizeArtboardCommandOption/types'
import { updateArtboardPosition, getNearbyArtboards, showTransfomerOutsideArtboard, artboardNewName, getOldValuesArtboard } from '@utils/artboard'
import { isParameterPropertyDeclaration } from 'typescript';

const ArtboardCanvasElement: React.FC<IProps> = (props) => {  
  let attributes = (props.element.attributes as IArtboardAttributes);
  const textRef = React.useRef() as React.MutableRefObject<Konva.Text>;
  const rectRef = React.useRef() as React.MutableRefObject<Konva.Rect>;  
  const groupRef = React.useRef() as React.MutableRefObject<Konva.Group>;
  const groupDragRef = React.useRef() as React.MutableRefObject<Konva.Group>;
  const rectInsideRef = React.useRef() as React.MutableRefObject<Konva.Rect>; 
  const groupResizeRef = React.useRef() as React.MutableRefObject<Konva.Group>; 
  const rectResizeRef = React.useRef() as React.MutableRefObject<Konva.Rect>;   
  const trResizeRef = React.useRef() as React.MutableRefObject<Konva.Transformer>;
  const labelResize = React.useRef() as React.MutableRefObject<Konva.Label>;  
  const textResize = React.useRef() as React.MutableRefObject<Konva.Text>;
  const oldNameValidate = React.useRef<string>("");
  
  const update_previews = props.updatePreviews;

  const nearbyArtboards= React.useRef({left: undefined, right: undefined, top: undefined, bottom: undefined});
  const [isTitleHovered, setIsTitleHovered] = useState(false);

  let oldValues : IResizeValues= getOldValuesArtboard(props.element);

  const handleSelect = (e: KonvaEventObject<MouseEvent>) => {
    props.onSelect(e);
  }

  const handleMouseEnter = (e: KonvaEventObject<MouseEvent>) => {
    if (props.editMode)
    {
      setIsTitleHovered(true);
      const container = e.target.getStage()?.container();
      if (container) container.style.cursor = "pointer";
    }
  }

  const handleMouseLeave = (e: KonvaEventObject<MouseEvent>) => {
    setIsTitleHovered(false);
    const container = e.target.getStage()?.container();
    if (container) container.style.cursor = "default";
  }

  useEffect(() => {
    if (props.isSelected && props.element && rectInsideRef.current && groupRef.current) {
      nearbyArtboards.current = {left: undefined, right: undefined, top: undefined, bottom: undefined};
      updateArtboardPosition(props.element.attributes, rectInsideRef, groupRef, undefined, rectResizeRef, textResize, textRef, groupResizeRef);
    }
    if (props.element && rectInsideRef.current && groupRef.current && textRef.current)
      reverseScale(textRef, props.element.attributes.y);
  }, [props.isSelected, props.element, rectInsideRef, groupRef, textRef]);

  useEffect(() => {
    if (props.isSelected && !props.showSelectDescribe) {
      trResizeRef.current?.nodes([rectResizeRef.current]);
      trResizeRef.current?.getLayer()?.batchDraw();
    }
  }, [props.isSelected, props.showSelectDescribe, props.layer]);

  useEffect(() => {
    if (props.exporting)
    {        
      if (props.exportingArtboards && props.exportingArtboards.length>0)
      {
        if (props.isSelected)
          DownloadArtboard();
      }
      else
        DownloadArtboard();      
    }
            
  }, [props.exporting]);

  useEffect(() => {
    setTimeout(() =>{
      let oldName =  false;
      if (props.previews) {
        let previewName = getArtboardPreview(props.previews, props.element.name);
        if (previewName) oldName = true;
        if (oldNameValidate.current!=='') {
          let previewOldName = getArtboardPreview(props.previews, oldNameValidate.current);
          if (previewOldName) oldName = true;
        }
      }
      if (oldName) {
        let name = props.element.id
        let data = GeneratePreview();
        let dataBig = GeneratePreviewBig();
        props.savingPreview([data,dataBig],name, true, true)
      }
    },3000)
  }, [props.element]);

  useEffect(() => {
    if (props.savingParsedTree && props.showSelectDescribe === false)
    {    
      setTimeout(() =>{
        let name = props.element.id;
        let data = GeneratePreview()  
        let dataBig = GeneratePreviewBig()          
        props.savingPreview([data,dataBig],name)
      },500)
     
    }

  }, [props.savingParsedTree])

  useEffect(() => {
    if (update_previews && update_previews === "true")
    {    
      const inmediate = true;
      setTimeout(() =>{
        let name = props.element.name        
        let data = GeneratePreview()  
        let dataBig = GeneratePreviewBig()          
        props.savingPreview([data,dataBig],name,inmediate)
      },90000)
     
    }

  }, [update_previews])

  const DownloadArtboard=()=>
  {
    let file_name = props.exportingProperties?.designName.replace(' ','_')+"_"+ props.element.name.replace(' ','_')+'.'+props.exportingProperties?.format.toLowerCase();      
    let quality =100;        
    if (props.exportingSizes && props.exportingProperties?.compressFiles)
    {          
      let expratio = props.exportingSizes.find(f=>f.id == props.element.id)
      quality = expratio && expratio.ratio? expratio.ratio:100;        
    }
    let format = (props.exportingProperties && props.exportingProperties.format)?props.exportingProperties.format.toLocaleLowerCase():""
    let dataURL = GetDataUrl(quality,format)
    if (dataURL)
    {
      if (props.exportingProperties?.location == "GALLERY")
      {
        dataURL = dataURL.replace("data:image/png;base64,","");
        dataURL = dataURL.replace("data:image/jpeg;base64,","");


        let exportName = props.exportingProperties.names && props.exportingProperties.names.find(f=>f.id == props.element.id);        
        
        //props.exportMedia(dataURL, props.exportingProperties.dealerId, props.exportingProperties.collection, props.exportingProperties.prefix,file_name,false,true);
        props.exportMedia(dataURL, props.exportingProperties.dealerId, props.exportingProperties.collection, props.exportingProperties.prefix,exportName?.savename,exportName?.overwrite,true);
      }
      else
        downloadURI(dataURL, file_name);    
      
    }

    
  }

  const GeneratePreview=()=>{
    let quality =props.previewConfig.quality;
    let scale = props.previewConfig.scale;
    let b64Data = GetDataUrl(quality,props.previewConfig.format ,scale)
    if (b64Data)
    {
      b64Data = b64Data.replace("data:image/png;base64,","");
      b64Data = b64Data.replace("data:image/jpeg;base64,","");
    }
    return b64Data
  }

  const GeneratePreviewBig =()=>{    
    let quality =props.previewConfig.qualityBig;
    let scale = props.previewConfig.scaleBig;
    if (scale>0)
    {
    let b64Data = GetDataUrl(quality,props.previewConfig.formatBig ,scale)
      if (b64Data)
      {
        b64Data = b64Data.replace("data:image/png;base64,","");
        b64Data = b64Data.replace("data:image/jpeg;base64,","");
      }
      return b64Data
    }
    return ""
  }

  const GetDataUrl= (quality:number, format:string, scale?:number ) =>
  { 
    if (groupRef && groupRef.current)
    {
      
      quality= quality/100
      let scaleX = groupRef.current.getStage()?.scaleX();
      let scaleY = groupRef.current.getStage()?.scaleY();

      groupRef.current.getStage()?.scale({ x: scale??1, y: scale??1 });      
      let posx = (groupRef.current.getStage()?.x()??0) + (attributes.x);
      let posy = (groupRef.current.getStage()?.y()??0) + (attributes.y);
      let height = attributes.height ;
      let width = attributes.width! ;    
      let stageHeight = groupRef.current.getStage()?.height()??700
      let stageWidth = groupRef.current.getStage()?.width()??1920
      groupRef.current.getStage()?.height(height/(scaleY??0.5));
      groupRef.current.getStage()?.width(width/(scaleX??0.5));
   
      if ((scale??1)<1)
      {
        posx = (groupRef.current.getStage()?.x()??0) + (attributes.x * (scale??1));
        posy = (groupRef.current.getStage()?.y()??0) + (attributes.y * (scale??1));
        height = height * (scale??1);
        width = width * (scale??1);
      }

      let dataUrl = groupRef.current.toDataURL({x: posx ,y:posy ,height:height, width:width, quality:quality, mimeType:"image/"+format, pixelRatio: 1 });
      groupRef.current.getStage()?.scale({ x:(scaleX??1) , y: (scaleY??1) });;   
      groupRef.current.getStage()?.height(stageHeight);
      groupRef.current.getStage()?.width(stageWidth);
      return dataUrl;

    }

  }

  const GetDefaultSize=() =>
  {
    let found =false;
    let quality = 100;
    let fileSize;
    let i =0;
    let minquality=0;
    let maxquality=100;    
    do{
      


      quality = Math.round(minquality + ((maxquality-minquality)/2));
      
      let dataURL = GetDataUrl(quality,"jpeg");            
      fileSize = getFileSize(dataURL)      
      if (fileSize>= (props.exportingValues?props.exportingValues.defaultMinSize:0) && fileSize<= (props.exportingValues?props.exportingValues.defaultMaxSize:0))
        found = true;
      else
      { 
        if (fileSize< (props.exportingValues?props.exportingValues.defaultMinSize:0))
        {
          if (quality==minquality)
            minquality = maxquality
          else
            minquality = quality;          

        }
        else
        {
          if (quality== maxquality)
            maxquality = minquality
          else
            maxquality = quality;        

        }        
        if (quality>100 || quality<=0 || (quality == maxquality && quality==minquality ))         
          found = true;
      }
      i++;
      if (i===100)
      {
        found =true;
      }
    }while(!found)
    
    props.onExportingCompress(fileSize,quality)



  }

  
  useEffect(() => {      
    if (props.exportingProperties && props.exportingProperties.compressRatios)
    {
          
      if (props.exportingProperties?.compressArtboard && props.exportingProperties.compressArtboard == props.element.id)
        SetArboardSize()          
      else if (props.exportingProperties?.compressArtboard===undefined)
        SetArboardSize()
    }
          
  }, [props.exportingProperties?.compressRatios]);
  
  const SetArboardSize=()=>
  {
    let quality =100;
    if (props.exportingProperties && props.exportingProperties.compressRatios)
    {
      let expratio = props.exportingProperties.compressRatios.find(f=>f.id === props.element.id)                 
      quality = (expratio && expratio.ratio)? expratio.ratio:0;        
    }          
    let format = (props.exportingProperties && props.exportingProperties.format)?props.exportingProperties.format.toLocaleLowerCase():""              
    if (quality>=0)
    {
      let dataURL = GetDataUrl(quality, format);
      if (dataURL)
      {                
        let fileSize = getFileSize(dataURL)          
        props.onExportingCompress(fileSize,quality)                   
      }
    }
    else
    {
        GetDefaultSize();
    }
  }

  const getFileSize= (b64Data:any) =>  {
    
    b64Data = b64Data.replace("data:image/png;base64,","");
    b64Data = b64Data.replace("data:image/jpeg;base64,","");
    let sizeInBytes = 4 * Math.ceil((b64Data.length / 3)) * 0.5624896334383812;
    return sizeInBytes;
  }
  
  function downloadURI(dataURL:any, name:any) {

    dataURL = dataURL.substring(dataURL[0].indexOf(',') + 1);

    var link = document.createElement('a');
    link.download = name;
    link.href = dataURL;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  useEffect(() => {
    if (props.zoom.value>1) {
      if (textRef.current) reverseScale(textRef, props.element.attributes.y);
      if (labelResize.current) reverseScale(labelResize, attributes.y);
    }

    if (rectRef.current && props.isSelected) {
      const absScale = textRef.current.getAbsoluteScale();
      let scaleY = textRef.current.scaleY() / absScale.y;
      rectRef.current.strokeWidth(2*scaleY)
    }
  }, [props.zoom]);


  const getRectBackGroundColor = () =>{
    if (props.exportingProperties && props.exportingProperties.tranparentBackground)
      return "";
    else
      return attributes.backgroundColor
  }
  
  const onTransform = (e: KonvaEventObject<Event>, transformEnd: boolean) => {
    const node = rectResizeRef.current;
    const activeAnchor = trResizeRef.current.getActiveAnchor();
    
    if (node) {
      let width = node.width() * node.scaleX();
      if (width > props.artboardResize.max || width < props.artboardResize.min) {
        node?.scaleX(1);
        node?.width(width < props.artboardResize.min ? props.artboardResize.min:props.artboardResize.max);
        if (activeAnchor==="top-left" || activeAnchor==="bottom-left") {
          let extra = node?.width() - props.element.attributes.width;
          node.x(props.element.attributes.x - extra); 
        }
      } else {
        node.width(width)           
        node?.scaleX(1);
      }

      let height = node.height() * node.scaleY();
      if (height > props.artboardResize.max || height < props.artboardResize.min) {
        node?.scaleY(1);
        node?.height(height < props.artboardResize.min ?  props.artboardResize.min : props.artboardResize.max);
        if (activeAnchor==="top-left" || activeAnchor==="top-right") {
          let extra = node?.height() - props.element.attributes.height;
          node.y(props.element.attributes.y - extra); 
        }
      } else {
        node.height(height)           
        node?.scaleY(1);
      }
    }

    if (node) { 
      node.height(node.height() * node.scaleY())
      node?.scaleY(1); 
      const newX = node.x(); 
      const newY = node.y(); 
      const newWidth = Math.trunc(node.width()); 
      const newHeight = Math.trunc(node.height()); 

      //Update text position
      if (activeAnchor==="top-left" || activeAnchor==="top-right" || activeAnchor==="bottom-left") {
        const nodeText = textRef.current;
        nodeText.x(newX);
        nodeText.y(newY-20);
        reverseScale(textRef, newY);
      }

      // Update group container
      const nodeGroup = groupRef.current;
      //x,y +1
      nodeGroup.clipX(newX);
      nodeGroup.clipY(newY);
      //width/height -2
      nodeGroup.clipWidth(newWidth);
      nodeGroup.clipHeight(newHeight);

      // Update rect inside group container
      const nodeRectInside = rectInsideRef.current;
      //x,y +1
      nodeRectInside.x(newX);
      nodeRectInside.y(newY);
      //width/height -2
      nodeRectInside.width(newWidth);
      nodeRectInside.height(newHeight);

      //Update tooltip resize text.
      const nodeLabelInfo = labelResize.current;
      nodeLabelInfo.visible(true);
      nodeLabelInfo.x(newX + ((newWidth/2)-(nodeLabelInfo.width()/2)));
      nodeLabelInfo.y(newY + newHeight+15);
      const nodeTextInfo = textResize.current;
      nodeTextInfo.text(`${Math.round(newWidth)}x${Math.round(newHeight)}`);
      
      const smallerX = props.element.attributes.width > newWidth;
      const smallerY = props.element.attributes.height > newHeight;
      const id: string = props.element.id as string;
      nearbyArtboards.current = getNearbyArtboards(nearbyArtboards.current, rectResizeRef, props.layer, oldValues, id, activeAnchor ?? '', props.artboardResize, smallerX, smallerY);

      if (transformEnd) showTransfomerOutsideArtboard(props.layer, groupResizeRef, 1); 
      else showTransfomerOutsideArtboard(props.layer, groupResizeRef); 
      //On resize end
      if (transformEnd) {
        nodeLabelInfo.visible(false);
        let resizeValues : IResizeValues={
          id: props.element.id,
          x: newX,
          y: newY,
          width: newWidth,
          height: newHeight,
          rotation: undefined,
          command: 'resizeArtboard',
          updateName: artboardNewName(props.element.name, newWidth, newHeight)
        }
        if (resizeValues.updateName) oldNameValidate.current = props.element.name;
        props.onResize(resizeValues, oldValues, activeAnchor, nearbyArtboards.current);
      }
    }
  };

  const handleDrag = (dragEnd:  boolean) => {
    const nodeResize = groupResizeRef.current;
    const nodeArtboard = groupRef.current;

    if (nodeResize && nodeArtboard) {
      if (dragEnd) {
        let resizeValues : IResizeValues={
          id: props.element.id,
          x: props.element.attributes.x + nodeArtboard.x(),
          y: props.element.attributes.y + nodeArtboard.y(),
          width: props.element.attributes.width,
          height: props.element.attributes.height,
          rotation: undefined,
          command: 'resizeArtboard'
        } 
        showTransfomerOutsideArtboard(props.layer, groupResizeRef, 1, groupRef); 
        props.onDragEnd(resizeValues, oldValues);
      } else {
        nodeArtboard.setPosition({x: nodeResize.x()  , y: nodeResize.y()});
        nodeArtboard.fire("dragmove");
      }
    }
  }
  
  return (
    <>
      <Group id={`artboard-resize-${props.element.id}`} 
      ref={groupResizeRef}
      draggable={props.isSelected && !props.showSelectDescribe} 
      onDragMove={() =>{
        handleDrag(false);
      }}
      onDragEnd={() =>{
        handleDrag(true);
      }}
      onDragStart = {() =>{
        showTransfomerOutsideArtboard(props.layer, groupResizeRef, undefined, groupRef); 
      }}> 
      <Text 
          ref = {textRef}
          name="artboard-title"
          onClick={(e: KonvaEventObject<MouseEvent>) => handleSelect(e)}
          onMouseEnter={(e: KonvaEventObject<MouseEvent>) => handleMouseEnter(e)}
          onMouseLeave={(e: KonvaEventObject<MouseEvent>) => handleMouseLeave(e)}
          x={attributes.x} 
          y={attributes.y-20} 
          text={props.element.name} 
          fill={props.isSelected && !props.showSelectDescribe ? C.BLUE_GREEN : C.GENERIC_GRAY} 
          fontFamily={"Roboto"}
        />
      {props.isSelected &&
      <>
      <Rect
        ref={rectResizeRef}
        x={attributes.x} 
        y={attributes.y} 
        width={attributes.width!} 
        height={attributes.height} 
        draggable={true}
        onTransform={(e) => {
          onTransform(e, false);
        }}
        onTransformEnd ={(e) => {
          onTransform(e, true);
        }}
      />
      <Transformer
          ref={trResizeRef}
          shouldOverdrawWholeArea={false}
          keepRatio={false}
          visible={true}
          rotateEnabled={false}
          draggable={false}
          borderStrokeWidth={2}
          borderStroke={C.BLUE_GREEN}  
          enabledAnchors={['top-left', 'top-right', 'bottom-left', 'bottom-right']}
          anchorSize={5}
        />
      </>}
      <Label ref={labelResize} x={attributes.x + ((attributes.width!)/2)}  y={attributes.y + attributes.height+ 15} visible={false}>
        <Tag fill={'rgba(73, 216, 222, 0.3)'} cornerRadius={4} />
        <Text 
            ref = {textResize}
            name="artboard-size"
            padding={7}
            text={props.element.name} 
            fontSize={11}
            fill={C.WHITE} 
            fontFamily={"Roboto"}
          />
      </Label>
      </Group>
      <Group
        id={props.element.id}
        clipX= {attributes.x}
        clipY ={attributes.y}
        clipWidth={attributes.width}
        clipHeight={attributes.height}
        type="artboard"
        onClick={(e: KonvaEventObject<MouseEvent>) => handleSelect(e)}
        ref={groupRef}
      >    
        <Rect ref={rectInsideRef} type="artboard-rect" fill={getRectBackGroundColor()} x={attributes.x} y={attributes.y} width={attributes.width} height={attributes.height}></Rect>
        {props.children}
      </Group>
    </>
  );
}

export default ArtboardCanvasElement;